module.exports = __webpack_public_path__ + "static/en-section-6@2x-6ced8e376c257565d4838d5ab80115db.png";